<template>
  <div style="margin-left: 20px">
    <!-- <div class="row">
      <TabMenu :model="menuitems" @tab-change="tabChange($event)" />
    </div> -->

    <div class="modal-body">
      <button
        type="button"
        class="
                    btn btn-outline-success
                    waves-effect waves-light
                    col-12
                  "
                  @click="savePaymentRequest()"
      >
        Send Payment Request
      </button>
      <fieldset class="floating-labels row mb-3">
        <div class="col-6">
          <h4 class="font-weight-bold">Patient Name:</h4>
          <div class="form-group">
            <input
              type="text"
              v-model="patientName"
              class="form-control"
              placeholder="Patient Name"
              disabled
            /><span class="bar"></span>
          </div>
        </div>

        <div class="col-6">
          <h4 class="font-weight-bold">Date Of Birth:</h4>
          <div class="form-group">
            <input
              type="text"
              v-model="patDOB"
              class="form-control"
              disabled
            /><span class="bar"></span>
          </div>
        </div>

        <div class="col-6">
          <h4 class="font-weight-bold">Date Of Service:</h4>
          <div class="form-group">
            <input
              type="text"
              v-model="patDOS"
              class="form-control"
              disabled
            /><span class="bar"></span>
          </div>
        </div>

        <div class="col-6">
          <h4 class="font-weight-bold">Amount Requested:</h4>
          <div class="form-group">
            <input
              type="number"
              class="form-control"
              v-model="aSingleRequestPayment.amount"
              placeholder="Amount Requested (In $$)"
            /><span class="bar"></span>
          </div>
        </div>

        <span
          class="mb-2"
          style="color: red; font-weight: bolder; font-size: small;"
          ><strong>Disclaimer</strong>: The patient will be sent request to
          entered delivery methods. If blank no notification will be sent.</span
        >

        <div class="col-6">
          <h4 class="font-weight-bold">Phone:</h4>
          <div class="form-group">
            <input
              v-mask="'###-###-####'"
              type="tel"
              class="form-control"
              v-model="aSingleRequestPayment.phone"
              placeholder="Phone"
            /><span class="bar"></span>
            <span class="text-danger" id=""></span>
          </div>
        </div>

        <div class="col-6">
          <h4 class="font-weight-bold">Email:</h4>
          <div class="form-group">
            <input
              type="text"
              class="form-control"
              v-model="aSingleRequestPayment.email"
              placeholder="Email"
            /><span class="bar"></span>
          </div>
        </div>

        <div class="col-6">
          <h4 class="font-weight-bold">Notes:</h4>
          <textarea
            class="form-control"
            v-model="aSingleRequestPayment.comment"
            rows="4"
            placeholder="Notes"
          ></textarea>
          <span class="bar"></span>
        </div>
        <div class="custom-file col-6" style="margin-top: 7px; height: 100%">
          <h4 class="font-weight-bold">Attach:</h4>
             <div class="form-group m-b-40 col-md-12 mb-3">
                <input
                  type="file"
                  id="fileUpload"
                  class='dropify'
                  accept="image/*"
                  @change="getImage"
                />
               
              </div>
        </div>
      </fieldset>
    </div>
  </div>
</template>

<script>
import localMixin from "./PaymentRequestComp";
import "vue-advanced-cropper/dist/style.css";

export default {
  name: "PaymentReceiveComponent",
  mixins: [localMixin],
  components: {},
  props: {
    p_visitId: Number,
  },
  data() {
    return {
      //forFile
      locationFile: "",
      fileName: null,
      SingleImage: {},
      img: {},

      //forPat
      patientName: "",
      patDOS: "",
      patDOB: "",

      showThisModel: false,
      pat: "",

      showRequestPayment: false,
      showCollectPayment: false,
      paymentMode: "credit-card",

      aSinglePaymentReceived: {
        pndx: 0,
        patientId: 0,
        practiceId: 0,
        visitId: 0,
        billNo: 0,
        collectedBy: 0,
        paymentDate: new Date(),
        amount: 0,
        paymentMethod: "",
        holderName: "",
        tdNumber: "",
        cardCVC: "",
        comment: "",
        zip: "",
      },

      aSingleRequestPayment: {
        amount: "",
        email: "",
        phone: "",
        comment: "",
      },

      activeIndex: 0,
      menuitems: [
        { label: "Credit Or Debit Card", icon: "far fa-credit-card" },
        { label: "Cash", icon: "fas fa-hand-holding-usd" },
        { label: "Cheque", icon: "fas fa-money-check-alt" },
      ],
    }; // data -- return
  }, // data
};
</script>

<style lang="scss" scoped></style>
